// RÈGLE PERMANENTE (cf. /app/memory/PRD.md) : les animations ne masquent jamais
// le contenu au chargement. Texte et images sont visibles par défaut
// (opacité 1, sans décalage) ; l'animation est un effet ajouté par-dessus,
// désactivé pour les robots, les navigateurs automatisés (pré-rendu) et
// prefers-reduced-motion.
export const animationsActives = () =>
  typeof window !== "undefined" &&
  typeof navigator !== "undefined" &&
  !navigator.webdriver &&
  !/bot|crawler|spider|crawling|slurp|prerender|headless/i.test(navigator.userAgent || "") &&
  !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
